import {
    VendorProject,
    VendorProjectFormData,
    safeDateOnly,
} from '../../models'

export type ProjectFieldErrors = Partial<
    Record<keyof VendorProjectFormData, string>
>

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/

export const todayYYYYMMDD = (): string => {
    const d = new Date()
    const m = `${d.getMonth() + 1}`.padStart(2, '0')
    const day = `${d.getDate()}`.padStart(2, '0')
    return `${d.getFullYear()}-${m}-${day}`
}

export const blankProjectForm = (): VendorProjectFormData => ({
    title: '',
    description: '',
    start_date: todayYYYYMMDD(),
    end_date: todayYYYYMMDD(),
    priority: 'MEDIUM',
    address: '',
})

export const projectToProjectForm = (
    project: VendorProject,
): VendorProjectFormData => ({
    title: project.title,
    description: project.description,
    start_date: safeDateOnly(project.start_date) ?? todayYYYYMMDD(),
    end_date: safeDateOnly(project.end_date) ?? todayYYYYMMDD(),
    priority: project.priority,
    address: project.address ?? '',
})

export const validateProjectFields = (
    form: VendorProjectFormData,
): ProjectFieldErrors => {
    const next: ProjectFieldErrors = {}
    if (!form.title.trim()) next.title = 'Title is required'
    if (form.title.length > 100) {
        next.title = 'Title must be 100 characters or fewer'
    }

    if (!form.start_date || !DATE_RE.test(form.start_date)) {
        next.start_date = 'Start date is required (YYYY-MM-DD)'
    }
    if (!form.end_date || !DATE_RE.test(form.end_date)) {
        next.end_date = 'End date is required (YYYY-MM-DD)'
    }

    if (!next.start_date && !next.end_date && form.end_date < form.start_date) {
        next.end_date = `End date (${form.end_date}) must be on or after start date (${form.start_date})`
    }

    const today = todayYYYYMMDD()
    if (!next.end_date && form.end_date < today) {
        next.end_date = 'End date cannot be in the past'
    }

    return next
}
